/**
 * 页面尚未挂载时的内容槽等待：HeroUI Spinner，不猜测页型。
 *
 * Callers: authenticated layout Suspense、壳外路由 Suspense、WorkspaceMembershipGate、审计内层 Suspense
 */

import { Spinner } from "@heroui/react";

type ContentSlotPendingProps = {
  /** 读屏标签（routeGuard.switching / common.tableLoading）。 */
  label: string;
};

/** 冷门控：内容区居中 Spinner；页挂载后改用 ContentAreaSkeleton。 */
export function ContentSlotPending({ label }: ContentSlotPendingProps) {
  return (
    <div className="flex min-h-[40vh] w-full items-center justify-center">
      <Spinner
        aria-label={label}
        className="motion-reduce:animate-none"
        size="lg"
      />
    </div>
  );
}
